var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "location-content",
      on: {
        click: function ($event) {
          return _vm.$emit("item-selected", _vm.location)
        },
      },
    },
    [
      _c("div", { staticClass: "loc-name" }, [
        _vm._v(_vm._s(_vm.location.title)),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "office-subtitle" }),
      _vm._v(" "),
      _c("div", { staticClass: "loc-addr" }, [
        _vm._v(
          _vm._s(_vm.location.address) +
            ", " +
            _vm._s(_vm.location.city) +
            ", " +
            _vm._s(_vm.location.state) +
            " " +
            _vm._s(_vm.location.zip)
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "loc-addr3" }),
      _vm._v(" "),
      _c("div", { staticClass: "loc-phone" }, [
        _vm._v(_vm._s(_vm.location.phone)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }